// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import MediaQuery from 'react-responsive';

import parcelshop from '../../images/evri-coupons.png';
import print from '../../images/print-free-icon2.png';
import pack from '../../images/pack-items-icon2.png';
import packAC from '../../images/pack-items-ac-icon.png';
import delivery from '../../images/delivery-icon2.png';
import deliveryAC from '../../images/select-delivery-ac-icon.png';
import styles from './styles';

class Stepper extends React.Component {
  state = {};

  renderStep = (image, imageStyle, label, alt, isCenter, isArrangeCollection = false) => {
    const centerTextStart = '(Click ';
    const centerTextEnd = ' for packaging guidelines)';
    const startConstraintsPackText = 'Max weight: 30KG.';
    const middleConstraintsPackText = 'Max box dimensions: 180cm long with a combined.';
    const endConstraintsPackText = 'Max length & circumference of 420cm.';
    const { classes } = this.props;
    return (
      <div className={classes.stepContainer}>
        <img className={imageStyle} src={image} alt={`step-${alt}`} />
        <span className={classes.label}>{label}</span>
        { isArrangeCollection
          ? (isCenter && (
            <span className={classes.packConstraintsContainer}>
              {startConstraintsPackText}
              <br />
              {middleConstraintsPackText}
              <br />
              {endConstraintsPackText}
            </span>))
          : (isCenter && (
            <span className={classes.packLinkContainer}>
              {centerTextStart}
              <Link to={'/packaging-guidelines'} className={classes.packLink}>here</Link>
              {centerTextEnd}
            </span>
          ))}
      </div>
    );
  }

  renderArrangeCollection = () => {
    const { classes } = this.props;
    const packText = 'PACK ITEMS & ATTACH LABEL';
    const storeText = 'SELECT DELIVERY OPTION BELOW';
    return (
      <div className={classes.mainContainer}>
        {this.renderStep(packAC, classes.pack, packText, 'pack',
          { start: '(Click ', end: ' for packaging guidelines)', link: '/packaging-guidelines' })}
        {this.renderStep(deliveryAC, classes.delivery, storeText, 'parcelshop')}
      </div>
    );
  }

  renderDefaultStepper = () => {
    const { classes } = this.props;
    const printText = 'PRINT FREE SHIPPING LABEL';
    const packText = 'PACK ITEMS & ATTACH LABEL';
    const storeText = 'SELECT DELIVERY OPTION BELOW';
    return (
      <div className={classes.mainContainer}>
        {this.renderStep(print, classes.print, printText, 'print',
          { start: '(Download ', end: ' or from email)', link: '/' })}
        {this.renderStep(pack, classes.pack, packText, 'pack',
          { start: '(Click ', end: ' for packaging guidelines)', link: '/packaging-guidelines' })}
        {this.renderStep(delivery, classes.delivery, storeText, 'parcelshop')}
      </div>
    );
  }

  render() {
    const {
      classes, isTradeCustomer, children, isArrangeCollection
    } = this.props;
    const printText = isTradeCustomer
      ? 'PRINT THE WELCOME PACK EMAILED TO YOU'
      : 'PRINT FREE SHIPPING LABEL EMAILED TO YOU';
    const packText = isTradeCustomer
      ? 'PACK ITEMS AND LEAVE A WELCOME PACK INSIDE EACH BOX'
      : 'PACK ITEMS & ATTACH LABEL';
    const storeText = 'TAKE TO ANY EVRI STORE';

    return (
      <div className={classes.mainContainer}>
        <MediaQuery maxWidth={449}>
          <div className={classes.yellowLineVertical}>
            <div className={classNames(classes.circle, classes.circleNum1)} />
            <div className={classNames(classes.circle, classes.circleNum2)} />
            <div className={classNames(classes.circle, classes.circleNum3)} />
          </div>
        </MediaQuery>
        <div className={classes.subContainer}>
          {this.renderStep(print, classes.print, printText, 'print')}
          <MediaQuery minWidth={450}><div className={classes.yellowLine} /></MediaQuery>
          {this.renderStep(pack, classes.pack, packText, 'pack', true, isArrangeCollection)}
          { !isArrangeCollection
          && <MediaQuery minWidth={450}><div className={classes.yellowLine} /></MediaQuery>}
          { !isArrangeCollection && (isTradeCustomer ? children
            : this.renderStep(parcelshop, classes.parcelshop, storeText, 'parcelshop'))}
        </div>
      </div>
    );
  }
}

Stepper.propTypes = {
  classes: PropTypes.object,
  isTradeCustomer: PropTypes.bool,
  children: PropTypes.any,
  isArrangeCollection: PropTypes.bool,
};

Stepper.defaultProps = {
  classes: {},
  isTradeCustomer: false,
  children: null,
  isArrangeCollection: false,
};

export default withStyles(styles)(Stepper);
